export const textCopy = {
  Flat: `The freeholder/s of the building may need a 
  licence and FSRA and you need to see it.`,
  Building: `The leaseholder in this building may need a 
  licence or FSRA and you need to see it.`,
};
